query GetCustomWorkOrderFields {
  customWorkOrderFields {
    id
    label
    values {
      id
      description
      indicator
    }
  }
}
